export const UserRole = {
  ADMIN: 1,
  USER: 2,
  EVALUATOR: 3,
} as const

export const UserRoleLabel: Record<UserRole, string> = {
  [UserRole.ADMIN]: "ADMIN",
  [UserRole.USER]: "USER",
  [UserRole.EVALUATOR]: "EVALUATOR",
}

export type UserRole = (typeof UserRole)[keyof typeof UserRole]
export type UserRoleLabel = (typeof UserRoleLabel)[keyof typeof UserRoleLabel]

export const UserRoleValue: Record<string, UserRole> = {
  ADMIN: UserRole.ADMIN,
  USER: UserRole.USER,
  EVALUATOR: UserRole.EVALUATOR,
}

export type UserRoleName = keyof typeof UserRole

// ======================
//  Helper Functions
// ======================

export function getRoleName(role: UserRole): UserRoleName {
  return UserRoleLabel[role] as UserRoleName
}

export function getRoleValue(role: UserRoleName): UserRole {
  return UserRole[role]
}

export function isValidRoleValue(value: number): value is UserRole {
  return Object.values(UserRole).includes(value as UserRole)
}

export function isValidRoleName(value: string): value is UserRoleName {
  return Object.keys(UserRole).includes(value)
}